import {
    useMemo,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    RequestMethods,
} from 'app/enums/common.enums'
import useEnumValues from 'app/hooks/useEnumValues'

import {
    ContainerUnitPrice,
} from '../ProformaInvoices.types'
import getFields from './ProformaInvoiceForm.fields'

const defaultProps = {
    onSuccess: undefined,
    onCancel: undefined,
    data: {},
    disabled: false,
}

export default function ProformaInvoiceForm({
    onSuccess,
    onCancel,
    data,
    requestParam,
    disabled,
}: Readonly<{
    onSuccess?: (c: ContainerUnitPrice & { action: RequestMethods }) => void,
    onCancel?: () => void,
    data?: ContainerUnitPrice,
    requestParam: RequestConfig,
    disabled?: boolean,
}>) {
    const getAllowedValues = useEnumValues()
    const fields = useMemo(() => {
        return getFields(getAllowedValues)
    }, [getAllowedValues])

    return (
        <FormWithControls
            onSuccess={onSuccess}
            value={data}
            name="containerunitpricerule"
            fields={fields}
            requestParams={requestParam}
            exists={Boolean(data?.id)}
            onCancel={onCancel}
            disabled={disabled}
            canDelete
        />
    )
}

ProformaInvoiceForm.defaultProps = defaultProps
